<template>
<div>
  <template v-if='withTitle && person && person.id'  >
    <v-subheader class='pl-0' >
      Editing {{person.first_name}} {{person.last_name}}
      <v-spacer></v-spacer>
    </v-subheader>
  </template>
  <v-layout >
    <v-flex>
      <object-form
        v-model='person'
        :errors="errors"
        :fields="fields" >

        <v-flex xs12 slot='title' >
        <v-select
          :items="titles"
          v-model='person.title'
          :outline="hasErrors('title')"
          :error-messages="getErrors('title')"
          label="title" >
        </v-select>
        </v-flex>

        <v-flex xs12 slot='email'>
          <v-text-field
            v-model='person.email'
            label='Email address'
            hint="Please provide a valid email address"
            :outline="hasErrors('email')"
            :error-messages="getErrors('email')"
            type='email' >
          </v-text-field>
        </v-flex>

        <template slot='date_of_birth'>
          <v-text-field
            v-model='person.date_of_birth'
            @click='showBdayPicker=true'
            @click:append='showBdayPicker=true'
            persistent-hint
            readonly
            append-icon='event'
            :outline="hasErrors('date_of_birth')"
            :hint="birthdayHint"
            :error-messages="getErrors('date_of_birth')"
            label="date of birth"></v-text-field>
            <v-dialog v-model='showBdayPicker' width='300' class='text-xs-center' >
              <birthday-picker
                @close='showBdayPicker=false'
                v-model='person.date_of_birth' >
              </birthday-picker>
            </v-dialog>
        </template>

        <phone-number-input
          slot='cell_phone' :verbose=false
          v-model='person.cell_phone' >
        </phone-number-input>

        <v-textarea slot='billing_address' box
          v-model='person.billing_address'
          persistent-hint
          hint="We'll use this address on invoices"
          label="Billing address" >
        </v-textarea>

        <v-textarea slot='notes' box
          v-model='person.notes'
          persistent-hint
          hint="Add any interesting information about the user here. For example, you might note who referred them, if they are related to another patient etc."
          label="Bio" >
        </v-textarea>
      </object-form  >
      <v-layout >
        <v-flex class='text-xs-center mt-3' >
          <v-btn v-if='showAllFields === false' @click='showAllFields = true' flat >
            {{ $t('buttons.showmore') }}
          </v-btn>
          <v-btn v-else @click='showAllFields = false' flat >
            {{ $t('buttons.showless') }}
          </v-btn>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex v-if='withSearch' xs12 sm6 >
      <person-list :with-edit='false' >
      </person-list>
    </v-flex>
  </v-layout>
</div>
</template>

<script>
import ObjectForm from '@/components/medicalaid/ObjectForm'
import BirthdayPicker from '@/components/pickers/BirthdayPicker'
import PhoneNumberInput from '@/components/PhoneNumberInput'
import PersonList from '@/components/medicalaid/PersonList'

import { TITLES } from '@/store/constants'

import moment from 'moment'

const MIN_FIELDS = [
  // 'first_name',
  // 'last_name',
  // 'cell_phone',
  // 'email',
  'date_of_birth',
  'billing_address',
  // 'nickname',
  'notes' // bio
]
const ALL_FIELDS = MIN_FIELDS.concat([
  'title',
  'initials',
  'home_phone',
  'work_phone',
  // 'id_number',
  'passport_number'
])

export default {
  name: 'PersonForm',
  components: {ObjectForm, BirthdayPicker, PersonList, PhoneNumberInput},
  props: {
    value: { type: Object },
    errors: { type: Object, required: false, default: () => { return {} } },
    withTitle: { type: Boolean, default: true },
    withSearch: { type: Boolean, default: false },
    customFields: { type: Array }
  },
  data () {
    return {
      person: {},
      showAllFields: false,
      titles: TITLES,
      showBdayPicker: false
    }
  },
  watch: {
    value: {
      immediate: true,
      handler () {
        if (this.value) {
          this.person = this.value
        }
      }
    },
    person () {
      if (this.person) {
        this.$emit('input', this.person)
      }
    },
    errors () {
      this.showAllFields = true
    }
  },
  methods: {
    hasErrors (field) {
      if (this.errors) {
        return field in this.errors
      }
      return false
    },
    getErrors (fieldName) {
      if (fieldName in this.errors) {
        return this.errors[fieldName]
      }
      return []
    }
  },
  computed: {
    fields () {
      if (this.customFields) { return this.customFields }
      if (this.showAllFields) {
        return ALL_FIELDS
      }
      return MIN_FIELDS
    },
    birthdayHint () {
      let birthDate = this.getObjectPath(this.person, 'date_of_birth', null)
      if (birthDate) {
        let yrs = moment.duration((moment() - moment(birthDate))).asYears()
        return `Exactly ${yrs} years young`
      }
      return 'in the format: YYYY-MM-DD'
    }
  },
  i18n: {
    messages: {
      en: {
        buttons: {
          showmore: 'Show more fields',
          showless: 'Show fewer fields'
        }
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// Person.vue?a34474cc